import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67d89291&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d89291",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d89291')) {
      api.createRecord('67d89291', component.options)
    } else {
      api.reload('67d89291', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67d89291&scoped=true&", function () {
      api.rerender('67d89291', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/tpm/index.vue"
export default component.exports